<template>
	<div class="reservation-app-form">
		<form @submit.prevent="onSubmitForm">
			<!-- 지역 선택 -->
			<ReservationAppFormItem :step="1" label-icon="ri-map-2-line">
				<ul class="select-list">
					<li
						class="select-list__item select-list__item--col3"
						@click="onClickBranchArea(item)"
						v-for="item in branchArea"
						:key="item.categoryId"
					>
						<div
							class="select-list__content"
							:class="{ 'is-active': item.categoryId === branchAreaCode }"
						>
							{{ item.categoryName }}
						</div>
					</li>
				</ul>
			</ReservationAppFormItem>

			<!-- 지점 선택 -->
			<ReservationAppFormItem :step="2" label-icon="ri-store-2-line">
				<ul class="select-list">
					<li
						class="select-list__item"
						:class="{
							'select-list__item--col2':
								item.mini_company.indexOf('하이모레이디') === -1,
						}"
						@click="onClickBranch(item)"
						v-for="item in branch"
						:key="item.mini_jijumcode"
					>
						<div
							class="select-list__content"
							:class="{
								'is-active': item.mini_jijumcode === submitParams.branchCode,
							}"
						>
							{{ item.mini_company }}
						</div>
					</li>
				</ul>

				<div v-if="isLadyHelpText" class="mt-1">
					<p class="form-help form-help--reference">
						현재 백화점지점은 어플 예약 서비스를 운영하지 않습니다.
					</p>
				</div>
			</ReservationAppFormItem>

			<!-- 날짜 및 시간 선택 -->
			<ReservationAppFormItem :step="3" label-icon="ri-calendar-check-line">
				<div v-if="isDatePicker">
					<v-date-picker
						@dayclick="onDayClick"
						:value="null"
						:attributes="attrs"
						:select-attribute="selectAttr"
						:min-date="reservationMinDate"
						locale="ko-KR"
						is-expanded
					></v-date-picker>

					<div class="has-time-help-text">예약 가능 일자</div>

					<div class="mt-1">
						<p class="form-help form-help--reference">
							현재 지점 예약상황에 따라 예약가능한 시간만 노출됩니다.
						</p>
						<p class="form-help form-help--reference">
							피팅 서비스는 온라인/앱 예약이 불가하오니 지점으로 문의 바랍니다.
						</p>
						<p class="form-help form-help--reference">
							지정관리를 원할 시에는 지점으로 문의 바라며, 추가비용이
							발생됩니다.
						</p>
						<p class="form-help form-help--reference">
							앱/온라인 예약은 평일예약만 가능합니다. 주말예약은 지점으로 문의
							바랍니다.
						</p>
						<p class="form-help form-help--reference">
							예약 대기는 기예약자 취소 시 예약 가능함을 알려주는 기능입니다.<br />
							(앱 알림 설정 ON 경우에 푸시메시지로 발송)
						</p>
					</div>
				</div>

				<div v-if="isReservationTime" class="reservation-time-area">
					<div
						class="reservation-time-box"
						v-if="reservationTime.amList.length"
					>
						<strong class="reservation-time-box__title"
							><i class="ri-time-fill"></i> 오전</strong
						>
						<ul class="select-list">
							<li
								class="select-list__item select-list__item--col4"
								@click="onClickReservationTime(item, 'AM')"
								v-for="item in reservationTime.amList"
								:key="item.TM_CODE"
							>
								<div
									class="select-list__content time-item-content"
									:class="[
										{
											'is-active':
												item.TM_CODE === submitParams.reservationTimeCode,
										},
										{
											'time-item-content--possible':
												item.timeStatus === 'possible',
										},
										{
											'time-item-content--waiting':
												item.timeStatus === 'waiting',
										},
										{
											'time-item-content--impossible':
												item.timeStatus === 'impossible',
										},
									]"
								>
									<div>{{ item.TM_NAME }}</div>
									<div class="time-item-content__status">
										<div v-if="item.timeStatus === 'possible'">예약 가능</div>
										<div v-if="item.timeStatus === 'waiting'">예약 대기</div>
										<div v-if="item.timeStatus === 'impossible'">예약 불가</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
					<div
						class="reservation-time-box"
						v-if="reservationTime.pmList.length"
					>
						<strong class="reservation-time-box__title"
							><i class="ri-time-fill"></i> 오후</strong
						>
						<ul class="select-list">
							<li
								class="select-list__item select-list__item--col4"
								@click="onClickReservationTime(item, 'PM')"
								v-for="item in reservationTime.pmList"
								:key="item.TM_CODE"
							>
								<div
									class="select-list__content time-item-content"
									:class="[
										{
											'is-active':
												item.TM_CODE === submitParams.reservationTimeCode,
										},
										{
											'time-item-content--possible':
												item.timeStatus === 'possible',
										},
										{
											'time-item-content--waiting':
												item.timeStatus === 'waiting',
										},
										{
											'time-item-content--impossible':
												item.timeStatus === 'impossible',
										},
									]"
								>
									<div>{{ item.TM_NAME }}</div>
									<div class="time-item-content__status">
										<div v-if="item.timeStatus === 'possible'">예약 가능</div>
										<div v-if="item.timeStatus === 'waiting'">예약 대기</div>
										<div v-if="item.timeStatus === 'impossible'">예약 불가</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
					<div class="reservation-time-info">
						<div
							class="
								reservation-time-info__item
								reservation-time-info__item--possible
							"
						>
							가능
						</div>
						<div
							class="
								reservation-time-info__item reservation-time-info__item--waiting
							"
						>
							대기
						</div>
						<div
							class="
								reservation-time-info__item
								reservation-time-info__item--impossible
							"
						>
							불가
						</div>
					</div>
				</div>
				<div v-else class="flex-centered">
					<FormInputHint :message="logReservation" large></FormInputHint>
				</div>
			</ReservationAppFormItem>

			<!-- 서비스 선택 -->
			<ReservationAppFormItem :step="4" label-icon="ri-star-s-line">
				<ul class="reservation-service">
					<li
						class="reservation-service__item"
						@click="onClickReservationCode(item)"
						v-for="item in reservationCode"
						:key="item.value"
					>
						<span>{{ item.name }}</span>
						<i class="ri-arrow-drop-right-line"></i>
					</li>
				</ul>
			</ReservationAppFormItem>

			<!-- 기타 요청사항 -->
			<ReservationAppFormItem :step="5" label-icon="ri-edit-2-line">
				<textarea
					v-model="submitParams.requirement"
					class="form-input"
					rows="5"
					placeholder="요청하실 사항이 있으면 말씀해주세요."
				></textarea>
			</ReservationAppFormItem>

			<div class="form-button">
				<AppButton
					type="submit"
					color="primary"
					x-large
					block
					:disabled="!isSubmit"
					>{{ submitText }}</AppButton
				>
			</div>
		</form>

		<!-- 지점 상세 다이어로그 -->
		<BaseDialog
			:options="branchDialogOptions"
			@okCallback="branchDialogOkCallback"
		>
			<template v-slot:message>
				<div class="shop-detail-contents">
					{{ branchDetailContents }}
				</div>
				<div class="map-container">
					<KakaoMap :address="branchAddress" isMarker></KakaoMap>
				</div>
			</template>
		</BaseDialog>
	</div>
</template>

<script>
import Vue from 'vue';
import VCalendar from 'v-calendar';
import '@/assets/css/custom-v-calendar.css';
Vue.use(VCalendar);

import AppButton from '@/components/common/Btn';
import FormInputHint from '@/components/common/FormInputHint';
import ReservationAppFormItem from './ReservationAppFormItem';
import BaseDialog from '@/components/common/BaseDialog';
import KakaoMap from '@/components/common/KakaoMap';

import shop from '@/mixins/shop';
import { getDateStr } from '@/utils/util';

import {
	fetchReservationDefault,
	fetchBranchAreaFromBranchName,
	fetchBranchArea,
	fetchBranchFromAreaCode,
	fetchReservationCode,
	fetchAvailableReservationDates,
	saveReservationNew,
} from '@/api';

const DEFAULT_LABELS = {
	step1: '지역 선택',
	step2: '지점 선택',
	step3: '날짜 및 시간 선택',
	step4: '서비스 선택',
	step5: '기타 요청사항',
};

export default {
	components: {
		AppButton,
		FormInputHint,
		ReservationAppFormItem,
		BaseDialog,
		KakaoMap,
	},
	mixins: [shop],
	data() {
		return {
			submitParams: {
				branchCode: '', // 예약 지점 코드
				reservationDate: '', // 예약 날짜
				reservationTimeCode: '', // 예약 시간 코드
				reservationTimeName: '', // 예약 시간 명칭
				reservationCode: '', // 예약 서비스 코드
				requirement: '', // 기타 요청사항
			},

			branchAreaCode: '',
			branchArea: [],
			branch: [],
			selectedShopItem: {}, // 선택된 지점 정보

			isLadyHelpText: false,

			isDatePicker: false,
			attrs: [
				{
					key: 'today',
					highlight: {
						contentClass: 'today',
					},
					dates: new Date(),
				},
				{
					key: 'hasTime',
					highlight: {
						contentClass: 'has-time',
					},
					dot: false,
					dates: [],
				},
			],
			selectAttr: {
				highlight: {
					contentClass: 'selected',
				},
			},

			isReservationTime: false,
			reservationTime: {
				amList: [],
				pmList: [],
			},
			logReservation: '',

			reservationCode: [],

			selectedTimeStatus: '',
			submitText: '예약하기',

			isSubmit: false,
		};
	},
	computed: {
		userId() {
			return this.$store.state.userStore.user.user_id;
		},
		userName() {
			return this.$store.state.userStore.user.user_name;
		},
		reservationMinDate() {
			const startDate = new Date(2021, 5, 1); // 2021.6.1 부터 예약 가능
			const nowDate = new Date();

			return startDate > nowDate ? startDate : nowDate;
		},
		routeBranchName() {
			return this.$route.params.branchName;
		},
		branchDetailContents() {
			return this.getShopDetailContents(this.selectedShopItem);
		},
		branchAddress() {
			// ar_addr1 주소 값 반환
			return this.selectedShopItem.ar_addr1 || '';
		},
		branchDialogOptions() {
			return {
				title: this.selectedShopItem.mini_company || '지점 정보',
				size: 'large',
				okLabel: '선택',
			};
		},
	},
	watch: {
		submitParams: {
			deep: true,
			handler(val) {
				const required =
					val.branchCode &&
					val.reservationDate &&
					val.reservationTimeCode &&
					val.reservationCode;

				const required2 =
					val.branchCode &&
					val.reservationDate &&
					val.reservationTimeCode &&
					this.selectedTimeStatus === 'waiting';

				if (required || required2) {
					this.isSubmit = true;
				} else {
					this.isSubmit = false;
				}
			},
		},
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.initLabels();
			this.setBranchArea();
			this.setReservationCode();

			this.routeBranchName
				? this.initMyBranch(this.routeBranchName)
				: this.renderReservationDefault();
		},
		initLabels() {
			for (const stepKey in DEFAULT_LABELS) {
				this.setReservationFormItemLabel(stepKey, DEFAULT_LABELS[stepKey]);
			}
		},
		setReservationFormItemLabel(stepKey, label) {
			const payload = {
				stepKey,
				label,
			};
			this.$store.commit(
				'reservationStore/setReservationFormItemLabel',
				payload,
			);
		},
		setOpenReservationFormItem(stepKey, isOpen) {
			const payload = {
				stepKey,
				isOpen,
			};
			this.$store.commit(
				'reservationStore/setOpenReservationFormItem',
				payload,
			);
		},
		setDisabledReservationFormItem(stepKey, isDisabled) {
			const payload = {
				stepKey,
				isDisabled,
			};
			this.$store.commit(
				'reservationStore/setDisabledReservationFormItem',
				payload,
			);
		},
		async renderReservationDefault() {
			const params = {
				userId: this.userId,
			};

			const { data } = await fetchReservationDefault(params);

			if (data.code === '00000') {
				const reservationDefault = data.reservationDefault;
				const branchName = reservationDefault.DEPT_NAME;

				this.initMyBranch(branchName);
			}
		},
		async initMyBranch(branchName) {
			const params = {
				branchName,
			};

			const { data } = await fetchBranchAreaFromBranchName(params);

			if (data.code === '00000') {
				{
					const categoryId = data.categoryId;
					const categoryName = data.categoryName;
					const isLady = data.isLady;

					const item = {
						categoryId,
						categoryName,
						isLady,
					};

					this.onClickBranchArea(item);
				}
				{
					const branchCode = data.branchCode;
					const branchName = data.branchName;

					this.setBranch(branchCode, branchName);
				}
			}
		},
		async setBranchArea() {
			const { data } = await fetchBranchArea();

			if (data.code === '00000') {
				this.branchArea = data.branchArea.map(v => {
					return {
						categoryId: v.category_id,
						categoryName: v.category_name,
						isLady: false,
					};
				});

				this.branchArea.unshift({
					categoryId: null,
					categoryName: '레이디 전용',
					isLady: true,
				});
			}
		},
		setBranch(branchCode, branchName) {
			this.initBundle();

			// 지점 코드 저장
			this.submitParams.branchCode = branchCode;

			// 선택한 지점으로 레이블 명칭 변경
			this.setReservationFormItemLabel('step2', branchName);
			// 지점 선택 닫기
			this.setOpenReservationFormItem('step2', false);

			this.renderAvailableReservationDates();
		},
		async setReservationCode() {
			const { data } = await fetchReservationCode();
			this.reservationCode = data;
		},
		async renderBranch(categoryId, isLady) {
			const params = {
				categoryId,
				isLady,
			};

			const { data } = await fetchBranchFromAreaCode(params);

			if (data.code === '00000') {
				this.branch = data.branch;
			}
		},
		getReservationTimeStatus(isRsrvPossible, isWaitingPossible) {
			if (isRsrvPossible === false && isWaitingPossible === true) {
				return 'waiting';
			}

			if (isRsrvPossible === false && isWaitingPossible === false) {
				return 'impossible';
			}

			return 'possible';
		},
		async renderReservationTimeAll(branchCode, reservationDate) {
			const payload = {
				branchCode,
				reservationDate,
			};
			return await this.$store
				.dispatch('reservationStore/getReservationTimeAll', payload)
				.then(({ data }) => {
					const message = data.message;

					if (data.code === '00000') {
						// 예약 시간대 렌더
						const reservationTime = data.list;

						this.isReservationTime = true;

						let amList = reservationTime.filter(v => v.TM_NAME.includes('AM'));
						let pmList = reservationTime.filter(v => v.TM_NAME.includes('PM'));
						amList = amList.map(v => {
							const timeStatus = this.getReservationTimeStatus(
								v.IS_RSRV_POSSIBLE,
								v.IS_WAITING_POSSIBLE,
							);

							return {
								TM_CODE: v.TM_CODE,
								TM_NAME: v.TM_NAME.replace('AM ', ''),
								timeStatus,
							};
						});
						pmList = pmList.map(v => {
							const timeStatus = this.getReservationTimeStatus(
								v.IS_RSRV_POSSIBLE,
								v.IS_WAITING_POSSIBLE,
							);

							return {
								TM_CODE: v.TM_CODE,
								TM_NAME: v.TM_NAME.replace('PM ', ''),
								timeStatus,
							};
						});
						this.reservationTime.amList = amList;
						this.reservationTime.pmList = pmList;
					} else if (data.code === '20002') {
						// 예약 시간대 없음
						this.isReservationTime = false;

						this.logReservation = message;
					} else {
						// 그 외 오류
						this.isReservationTime = false;

						this.logReservation = '';

						const options = {
							message,
						};
						this.showAlert(options);
					}
				});
		},
		async renderAvailableReservationDates() {
			const st = new Date();
			st.setDate(st.getDate() + 1);

			const ed = new Date();
			ed.setDate(ed.getDate() + 60);

			const branchCode = this.submitParams.branchCode;
			const startDate = getDateStr(st);
			const endDate = getDateStr(ed);

			const params = {
				branchCode,
				startDate,
				endDate,
			};

			const { data } = await fetchAvailableReservationDates(params);

			if (data.code === '00000') {
				const { dates } = data;

				const result = dates.map(v => v.WORK_DT);
				const filterResult = result.filter(
					(item, index) => result.indexOf(item) === index,
				);

				this.attrs[1].dates = filterResult.map(dateStr => {
					const y = dateStr.substr(0, 4);
					const m = dateStr.substr(4, 2);
					const d = dateStr.substr(6, 2);

					return new Date(`${y}/${m}/${d}`);
				});

				// 데이트피커 활성화
				this.isDatePicker = true;
				// 날짜 및 시간 선택 활성화
				this.setDisabledReservationFormItem('step3', false);
				// 날짜 및 시간 선택 열기
				this.setOpenReservationFormItem('step3', true);
			} else {
				const message = data.message;
				const options = {
					message,
				};
				this.showAlert(options);
			}
		},
		initSubmitParams() {
			this.submitParams.branchCode = '';
			this.submitParams.reservationDate = '';
			this.submitParams.reservationTimeCode = '';
			this.submitParams.reservationTimeName = '';

			// 서비스 및 기타 요청사항은 편의성을 위해 초기화 하지 않음.
			// this.submitParams.reservationCode = '';
			// this.submitParams.requirement = '';
		},
		initReservationTime() {
			this.isReservationTime = false;
			this.reservationTime.amList = [];
			this.reservationTime.pmList = [];
			this.logReservation = '';
		},
		initBundle() {
			// 제출 파라미터 초기화
			this.initSubmitParams();

			// 예약 날짜 및 시간 초기화
			this.initReservationTime();

			// 데이트피커 비활성화
			this.isDatePicker = false;

			// 초기화
			this.setReservationFormItemLabel('step2', DEFAULT_LABELS.step2);
			this.setReservationFormItemLabel('step3', DEFAULT_LABELS.step3);

			this.setOpenReservationFormItem('step3', false);
			this.setDisabledReservationFormItem('step3', true);
		},
		// 지역 선택
		onClickBranchArea(item) {
			const categoryId = item.categoryId;
			const categoryName = item.categoryName;
			const isLady = item.isLady; // 하이모레이디 지점

			// 지역 코드 저장
			this.branchAreaCode = categoryId;
			// 선택한 지역으로 레이블 명칭 변경
			this.setReservationFormItemLabel('step1', categoryName);
			// 지역 선택 닫기
			this.setOpenReservationFormItem('step1', false);

			// 지점 선택 활성화
			this.setDisabledReservationFormItem('step2', false);
			// 지점 선택 열기
			this.setOpenReservationFormItem('step2', true);

			// 지역과 관련된 지점 리스트 가져오기
			this.renderBranch(categoryId, isLady);

			if (isLady) {
				this.isLadyHelpText = true;
			} else {
				this.isLadyHelpText = false;
			}

			this.initBundle();
		},
		// 지점 선택
		onClickBranch(item) {
			// 선택된 지점 정보 저장
			this.selectedShopItem = item;
			// 다이얼로그 열기
			this.$store.dispatch('dialogStore/openDialog');
		},
		branchDialogOkCallback() {
			const branchCode = this.selectedShopItem.mini_jijumcode;
			const branchName = this.selectedShopItem.mini_company;
			this.setBranch(branchCode, branchName);
		},
		onDayClick(day) {
			const reservationDate = day.id.replace(/\D/g, '');

			if (this.submitParams.reservationDate !== reservationDate) {
				this.submitParams.reservationTimeCode = '';
			}

			const branchCode = this.submitParams.branchCode;

			// 선택한 날짜 데이터에 저장
			this.submitParams.reservationDate = reservationDate;

			// 선택한 예약 날짜에 해당되는 예약 시간 불러오기
			// this.renderReservationTime(branchCode, reservationDate);
			this.renderReservationTimeAll(branchCode, reservationDate);
		},
		onClickReservationTime(item, timeUnit) {
			// 선택한 시간대 상태 저장
			this.selectedTimeStatus = item.timeStatus;

			if (item.timeStatus === 'impossible') {
				const options = {
					message: '예약 불가능한 시간대입니다.',
				};
				this.showAlert(options);
				return;
			}

			// 예약 시간 코드 데이터에 저장
			this.submitParams.reservationTimeCode = item.TM_CODE;

			const year = this.submitParams.reservationDate.substr(0, 4);
			const month = this.submitParams.reservationDate.substr(4, 2);
			const day = this.submitParams.reservationDate.substr(6, 2);
			let dateStr = `${year}.${month}.${day}`;

			let timeStr = '';
			if (timeUnit === 'AM') {
				timeStr = `오전 ${item.TM_NAME.replace('AM ', '')}`;
			} else {
				timeStr = `오후 ${item.TM_NAME.replace('PM ', '')}`;
			}

			this.submitParams.reservationTimeName = `${timeUnit} ${item.TM_NAME.replace(
				timeUnit + ' ',
				'',
			)}`;

			// 선택한 예약 날짜/시간으로 레이블 명칭 변경
			this.setReservationFormItemLabel('step3', `${dateStr} ${timeStr}`);
			// 날짜 및 시간 닫기
			this.setOpenReservationFormItem('step3', false);

			if (item.timeStatus === 'possible') {
				this.submitText = '예약하기';

				// 서비스 선택 활성화
				this.setDisabledReservationFormItem('step4', false);
				// 서비스 선택 열기
				this.setOpenReservationFormItem('step4', true);
			}

			if (item.timeStatus === 'waiting') {
				this.submitText = '예약대기';

				// 서비스 선택 레이블 기본 명칭으로 변경
				this.setReservationFormItemLabel('step4', DEFAULT_LABELS.step4);

				// 서비스 선택 비활성화
				this.setDisabledReservationFormItem('step4', true);
				// 서비스 선택 닫기
				this.setOpenReservationFormItem('step4', false);
				// 서비스 코드 초기화
				this.submitParams.reservationCode = '';

				// 기타 요청사항 비활성화
				this.setDisabledReservationFormItem('step5', true);
				// 기타 요청사항 닫기
				this.setOpenReservationFormItem('step5', false);
				// 기타 요청사항 내용 초기화
				this.submitParams.requirement = '';
			}
		},
		onClickReservationCode(item) {
			// 예약 서비스 코드 저장
			this.submitParams.reservationCode = item.value;

			// 선택한 예약 서비스로 레이블 명칭 변경
			this.setReservationFormItemLabel('step4', item.name);
			// 예약 서비스 닫기
			this.setOpenReservationFormItem('step4', false);

			// 기타 요청사항 활성화
			this.setDisabledReservationFormItem('step5', false);
			// 기타 요청사항 열기
			this.setOpenReservationFormItem('step5', true);
		},
		onSubmitForm() {
			if (this.selectedTimeStatus === 'possible') {
				this.submitReservation();
			}

			if (this.selectedTimeStatus === 'waiting') {
				this.submitReservationWaiting();
			}
		},
		async submitReservation() {
			const params = this.submitParams;
			params.userId = this.userId;

			const { data } = await saveReservationNew(params);

			if (data.code === '00000') {
				const labels =
					this.$store.getters['reservationStore/reservationFormItemLabels'];
				const result = {
					selectedTimeStatus: this.selectedTimeStatus,
					branchName: labels.step2,
					reservationDate: labels.step3.split(' ')[0],
					reservationTime: `${labels.step3.split(' ')[1]} ${
						labels.step3.split(' ')[2]
					}`,
					reservationService: labels.step4,
				};

				this.$store.commit('reservationStore/setFormData', result);

				this.$emit('nextPage');

				return;
			}

			if (data.code !== '00000') {
				const message = data.errorMessage
					? data.errorMessage
					: data.message ||
					  '온라인 예약이 되지 않았습니다. 예약관련 문의 1588-5858';
				const options = {
					message,
				};
				this.showAlert(options);

				return;
			}
		},
		async submitReservationWaiting() {
			const params = this.submitParams;
			params.userId = this.userId;
			params.userName = this.userName;
			params.categoryName =
				this.$store.getters['reservationStore/reservationFormItemLabel'](
					'step2',
				);

			const { data } = await this.$store.dispatch(
				'reservationStore/insertReservationWaiting',
				params,
			);

			if (data.code === '00000') {
				const labels =
					this.$store.getters['reservationStore/reservationFormItemLabels'];
				const result = {
					selectedTimeStatus: this.selectedTimeStatus,
					branchName: labels.step2,
					reservationDate: labels.step3.split(' ')[0],
					reservationTime: `${labels.step3.split(' ')[1]} ${
						labels.step3.split(' ')[2]
					}`,
				};

				this.$store.commit('reservationStore/setFormData', result);

				this.$emit('nextPage');
			} else {
				const message =
					data.message ||
					'죄송합니다. 시스템 오류로 예약 대기 신청에 실패했습니다.';
				const options = {
					message,
				};
				this.showAlert(options);
			}
		},
	},
};
</script>

<style scoped>
.reservation-app-form {
	padding: 1rem 0;
}

/* 셀렉트 버튼 */
.select-list {
	display: flex;
	flex-flow: row wrap;
	margin: -0.1875rem;
}

.select-list__item {
	flex: 0 0 100%;
	padding: 0.1875rem;
}

.select-list__item--col4 {
	flex: 0 0 25%;
}

.select-list__item--col3 {
	flex: 0 0 33.333333334%;
}

.select-list__item--col2 {
	flex: 0 0 50%;
}

.select-list__content {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 2.5rem;
	border-radius: 0.125rem;
	border: 1px solid #c8c8c8;
	background: #fff;
	font-size: 0.875rem;
	font-weight: 300;
	letter-spacing: -0.05em;
	text-align: center;
}

.select-list__content.is-active {
	border-color: #222;
	background: #222;
	color: #fff;
	font-weight: 500;
}

.time-item-content {
	height: 3.75rem;
}

.time-item-content.is-active {
	border-color: #c8c8c8;
	background: var(--blue-color);
	color: #fff;
	font-weight: 500;
}

.time-item-content--possible .time-item-content__status {
	color: var(--blue-color);
}

.time-item-content--possible.is-active .time-item-content__status {
	color: #fff;
}

.time-item-content--impossible {
	background: #ededed;
	color: #c8c8c8;
}

.time-item-content__status {
	font-size: 0.8125rem;
	line-height: 1.2;
}

/* 예약 시간 선택 */
.reservation-time-area {
	margin-top: 1.875rem;
}

.reservation-time-box:not(:first-child) {
	margin-top: 1.875rem;
}

.reservation-time-box__title {
	display: flex;
	align-items: center;
	margin-bottom: 0.75rem;
	font-size: 0.875rem;
	font-weight: 300;
}

.reservation-time-box__title i {
	padding-right: 0.25rem;
}

/* 예약 가능 일자 텍스트 */
.has-time-help-text {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 0.5em;
	color: #333;
	margin: 0 0 0.5em;
	font-size: 0.875rem;
}

.has-time-help-text::before {
	content: '';
	display: block;
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background-color: #c9dfff;
}

/* 예약 시간대 상태 안내 */
.reservation-time-info {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-end;
	align-items: center;
	margin-top: 0.75rem;
}

.reservation-time-info__item {
	position: relative;
	margin: 0 0.3rem;
	padding-left: 16px;
	font-size: 0.8125rem;
}

.reservation-time-info__item::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	width: 10px;
	height: 10px;
	margin: auto 0;
	border-radius: 2px;
	background: var(--base-color);
}
.reservation-time-info__item--possible::before {
	background: var(--blue-color);
}
.reservation-time-info__item--waiting::before {
	background: var(--base-color);
}
.reservation-time-info__item--impossible::before {
	background: #ededed;
}

/* 서비스 선택 */
.reservation-service {
	padding: 0 1.5625rem;
}

.reservation-service__item {
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 3.75rem;
	border-bottom: 1px solid #e2e2e2;
	font-size: 1rem;
	font-weight: 500;
}

.reservation-service__item i {
	color: #c8c8c8;
	font-size: 1.25rem;
}

/* 지점 상세 다이어로그 */
.shop-detail-contents {
	text-align: left;
}

.map-container {
	margin-top: 1rem;
}
</style>
